import { BANK_ACCOUNTS } from "../constants/actionTypes";
import initialState from "./initialState";

export default function bankAccounts(state = initialState.bankAccounts, action) {
  switch (action.type) {
    case BANK_ACCOUNTS.SHOW_DELETE_MODAL:
      return {
        ...state,
        allocationIdToDelete: action.allocationId,
        showDeleteModal: action.showModal
      };
    case BANK_ACCOUNTS.BANK_ACCOUNT_DELETED:
      return {
        ...state,
        bankAccountDeleted: action.payload
      };
    case BANK_ACCOUNTS.SET_BANK_ACCOUNT_DISBURSEMENT_HISTORY:
      return {
        ...state,
        disbursementHistory: {
          showDisbursementHistory: action.payload.showDisbursementHistory,
          bankAccountName: action.payload.bankAccountName,
          bankAccountNumber: action.payload.bankAccountNumber,
          disbursementHistory: action.payload.disbursementHistory
        }
      };
    case BANK_ACCOUNTS.SET_SELECTED_COUNTRY:
      return {
        ...state,
        availableCurrencies: action.currencies,
        destinationCountryName: action.destinationCountryName
      };
    case BANK_ACCOUNTS.SET_SELECTED_CURRENCY:
      return {
        ...state,
        destinationCurrencyName: action.destinationCurrencyName,
        destinationCurrencyCode: action.destinationCurrencyCode
      };
    case BANK_ACCOUNTS.SAVE_BANK_ACCOUNT_OPTIONS_VALUES:
      return {
        ...state,
        natureOfRelationshipOptions: action.payload.natureOfRelationshipOptions,
        beneficiaryCountryOptions: action.payload.beneficiaryCountryOptions,
        residentialStatusOptions: action.payload.residentialStatusOptions,
        bankAccountTypeOptions: action.payload.bankAccountTypeOptions
      };
    case BANK_ACCOUNTS.UPDATE_BANK_ACCOUNT_FORM_FIELDS:
      return {
        ...state,
        pages: action.pages
      };
    case BANK_ACCOUNTS.SET_BANK_ACCOUNT_BENE_BANK_DETAILS:
      return {
        ...state,
        pages: action.pages,
        instructionHeader: action.instructionHeader,
        instructionBody: action.instructionBody,
        nonFieldValidationErrors: action.nonFieldValidationErrors
      };
    case BANK_ACCOUNTS.UPDATE_BANK_ACCOUNT_FLOW_TYPE:
      return {
        ...state,
        type: action.flowType,
        allocationId: action.allocationId
      };
    case BANK_ACCOUNTS.RESET_BANK_ACCOUNT_STATE:
      return {
        ...initialState.bankAccounts,
        type: action.flowType ? action.flowType : null
      };
    case BANK_ACCOUNTS.SET_SHOW_CANCEL_MODAL:
      return {
        ...state,
        showCancelModal: action.payload
      };
    default:
      return state;
  }
};